export interface AccountInfoResult {
  account_hash: string;
  url: string;
  is_active: boolean;
  deploy_hash: string;
  verified_account_hashes: string[];
  info?: {
    owner?: AccountInfoOwner;
    nodes?: Array<AccountInfoNode>;
  };
}

export interface AccountInfoResult {
  account_hash: string;
  url: string;
  is_active: boolean;
  deploy_hash: string;
  verified_account_hashes: string[];
  balance?: number;
  genesis_balance?: string;
  main_purse_uref?: string;
  delegated_balance?: string;
  staked_balance?: string;
  undelegating_balance?: string;
  auction_status?: string;
  deployment_threshold: number;
  key_management_threshold: number;
  account_info?: AccountInfoResult;
  centralized_account_info?: AccountCentralizedInfo;
  public_key?: string;
  cspr_name?: string;
}

export interface AccountInfoOwner {
  name?: string;
  description?: string;
  type?: Array<string>;
  email?: string;
  identity?: {
    ownership_disclosure_url?: string;
    casper_association_kyc_url?: string;
    casper_association_kyc_onchain?: string;
  };
  resources?: {
    code_of_conduct_url?: string;
    terms_of_service_url?: string;
    privacy_policy_url?: string;
    other?: Array<{
      name?: string;
      url?: string;
    }>;
  };
  affiliated_accounts?: Array<AccountInfoAffiliatedAccount>;
  website?: string;
  branding?: {
    logo?: {
      svg?: string;
      png_256?: string;
      png_1024?: string;
    };
  };
  location?: {
    name?: string;
    country?: string;
    latitude?: number;
    longitude?: number;
  };
  social?: {
    github?: string;
    medium?: string;
    reddit?: string;
    wechat?: string;
    keybase?: string;
    twitter?: string;
    youtube?: string;
    facebook?: string;
    telegram?: string;
  };
}

export interface AccountInfoNode {
  public_key?: string;
  description?: string;
  functionality?: string[];
  location?: {
    name?: string;
    country?: string;
    latitude?: number;
    longitude?: number;
  };
}

export interface AccountInfoAffiliatedAccount {
  public_key?: string;
}

export interface AccountCentralizedInfo {
  account_hash: string;
  url: string;
  name: string;
  avatar_url: string;
}

export interface GeneralizedAccountInfo {
  logo: string | null;
  name?: string;
}

export interface AccountPendingUndelegation {
  amount: number;
  block_height: number;
  bonding_purse: string;
  deploy_hash: string | null;
  era_id: number;
  public_key: string | null;
  staker_identifier: string | null;
  timestamp: string;
  validator_account_info?: AccountInfoResult;
  validator_public_key: string;
  withdrawal_type_id: number;
}

export function AccountInfo(obj: any): AccountInfoResult {
  return obj;
}

export const getAccountInfoLogo = (
  accountInfo: AccountInfoResult | null | undefined
): string | null => {
  if (!accountInfo) return null;

  const logo = accountInfo.info?.owner?.branding?.logo;

  if (logo?.svg) {
    return logo?.svg;
  }

  if (logo?.png_256) {
    return logo?.png_256;
  }

  return null;
};

export const getCentralizedAccountInfoLogo = (
  accountInfo: AccountCentralizedInfo | null | undefined
): string | null => {
  if (!accountInfo) return null;

  const logo = accountInfo.avatar_url;

  if (logo) {
    return logo;
  }

  return null;
};
